import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'

// import {session} from './storage/storage';

// sessionStorage.clear();
// console.log('清理了')


/* import '@/lib-flexible/flexible.js' */

// import BaiduMap from 'vue-baidu-map'
// Vue.use(BaiduMap,{
//     ak:'20130716024058'		
// })


// import VueAMap from 'vue-amap'; // 高德
// VueAMap.initAMapApiLoader({
// 	key: 'e495c4bc4f1060024937343171d794b3',
// 	plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation'],
// 	v: '1.4.4'
// });
// Vue.use(VueAMap);
import VueObserveVisibility from 'vue-observe-visibility';
Vue.use(VueObserveVisibility);

import 'swiper/css/swiper.css'
import 'animate.css'
import animated from 'animate.css'
import 'lazysizes';
Vue.use(animated)
Vue.config.productionTip = false
Vue.prototype.$api={}
 
import Videojs from 'video.js'




import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import './assets/common/css/video.css'
import Carousel from '@/components/carousel.vue'
Vue.use(VideoPlayer)

Vue.prototype.$video = Videojs
Vue.component('Carousel', Carousel)
// import './elementui'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css'
Vue.use(ElementUI)

import vuescroll from 'vue-scroll';
Vue.use(vuescroll, { debounce: 600 });
/* import 'animate.css' */
import song from '@/song'
Vue.prototype.$store = store
Vue.use(song)
const app = new Vue({
	router,
	store,
  render: h => h(App),
})
import Api from './api/api.js'
import utils from './api/utils.js'
Vue.use(Api,app)
Vue.prototype.$utils = utils;
app.$mount('#app')
